var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, IsBoolean, IsDate, IsEnum, IsInt, IsOptional, IsString, IsUUID, Min, ValidateNested, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
import { CreateAppointmentSeriesParticipantDto } from './create-appointment-series.dto.js';
/**
 * Update a single occurrence of a series — materializes the row as an
 * override if it doesn't yet exist, then applies the changes.
 *
 * The route's `:occurrenceKey` path parameter identifies which occurrence;
 * this body carries only the fields to change.
 */
export class UpdateAppointmentSeriesOccurrenceDto {
    scheduledStart;
    plannedDuration;
    treatmentLocation;
    therapistId;
    roomId;
    officeProductAssignmentId;
    service;
    description;
    deviceIds;
    participants;
    confirmConflicts;
}
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "scheduledStart", void 0);
__decorate([
    IsInt(),
    Min(1),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "plannedDuration", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "therapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "roomId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "description", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "deviceIds", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ArrayMaxSize(5),
    ValidateNested({ each: true }),
    Type(() => CreateAppointmentSeriesParticipantDto),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "participants", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateAppointmentSeriesOccurrenceDto.prototype, "confirmConflicts", void 0);
//# sourceMappingURL=update-occurrence.dto.js.map